import { createTheme } from '@abyss/web/tools/theme';
import { OverlayProvider } from '@abyss/web/ui/OverlayProvider';
import { RouterProvider } from '@abyss/web/ui/RouterProvider';
import { ThemeProvider } from '@abyss/web/ui/ThemeProvider';
import { ToastProvider } from '@abyss/web/ui/Toast';

import { ProviderDirectory } from '../../common/ProviderDirectory/ProviderDirectory';
import ProviderDirectoryFooter from '../../common/ProviderDirectory/ProviderDirectoryFooter';
import ProviderDirectoryHeader from '../../common/ProviderDirectory/ProviderDirectoryHeader';
import { ErrorBoundary } from '../../errors/ErrorBoundary';
import { Configuration } from './context/Configuration/Configuration';
import { createRouter } from './createRouter';

export const App = () => {
  const theme = createTheme('uhc', {});
  return (
    <ErrorBoundary>
      <OverlayProvider>
        <ThemeProvider theme={theme}>
          <ToastProvider containerWidth="26rem" position="top-right" />
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
            }}
          >
            <ProviderDirectoryHeader />
            <ProviderDirectory />
            <ProviderDirectoryFooter />
          </div>
        </ThemeProvider>
      </OverlayProvider>
    </ErrorBoundary>
  );
};

const router = createRouter(App);

export const DocumentDirectory = () => (
  <ErrorBoundary>
    <Configuration>
      <RouterProvider router={router}></RouterProvider>
    </Configuration>
  </ErrorBoundary>
);
